import { render, staticRenderFns } from "./PopupDislikeFavoriteMeal.vue?vue&type=template&id=43d3bfc7"
import script from "./PopupDislikeFavoriteMeal.vue?vue&type=script&lang=js"
export * from "./PopupDislikeFavoriteMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports